@if (isLoading) {
  <div class="loading-screen">
    <app-spinner></app-spinner>
  </div>
}

@if (!isLoading) {
<div class="flex-container"
    [style]="cssVariables"
    [style.background-image]="(!isCustomCommunity ? 'url(' + bgImage + ')' : '')">
    <div class="image-div">
      @if (isCustomCommunity || hideByLogo()) {
        <img class="logo positive"
          [src]="(community.logoHorizontal || community.image || community.logoHorizontalNegative || community.logoNegative) | imageUrl"
          [attr.alt]="community.name"
          loading="lazy" />
        <img class="logo negative"
          [src]="(community.logoHorizontalNegative || community.logoNegative || community.logoHorizontal || community.image) | imageUrl"
          [attr.alt]="community.name"
          loading="lazy" />

        @if (!hideByLogo()) {
          @if (isWeCoo) {
            <div class="by-weco">
              <span>by</span>
              <img class="logo negative" src="assets/logos/wecoo/horizontal-white.svg" alt="Wecoo" />
              <img class="logo positive" src="assets/logos/wecoo/horizontal-black.svg" alt="Wecoo" />
            </div>
          } @else {
            <div class="by-wetown">
              <span>by</span>
              <img class="logo negative" src="assets/logos/wetown/horizontal-white.svg" alt="WeTown" />
              <img class="logo positive" src="assets/logos/wetown/horizontal-black.svg" alt="WeTown" />
            </div>
          }
        }
      } @else {
        <img [src]="logoImage" [attr.alt]="isWeCoo ? 'Wecoo' : 'WeTown'">
      }

      <span>{{ 'PASSWORD_RESET.RestartPassword' | translate }}</span>
    </div>

    <form [formGroup]="form">
        <div class="pass-div">
            <label for="password">{{ 'PASSWORD_RESET.NewPassword' | translate }}</label>
            <input
                id="password"
                name="password"
                type="password"
                pInputText
                formControlName="password"
                [attr.aria-invalid]="submitAttempt && form.get('password').invalid ? true : null"
                [class.error-input]="submitAttempt && (form.get('password').hasError('required') || form.get('confirmPassword').hasError('minLength'))"
            >
            @if (submitAttempt && form.get('password').hasError('required')) {
              <div class="error-message">
                <span style="color: red">{{ 'RequiredField' | translate }}</span>
              </div>
            }
            @if ((submitAttempt && form.get('password').hasError('minlength')) || (form.dirty && form.get('password').hasError('minlength'))) {
              <div class="error-message">
                <span style="color: red">{{ 'PASSWORD_RESET.Min6Caracters' | translate }}</span>
              </div>
            }
        </div>

        <div class="pass-div">
            <label for="confirmPassword">{{ 'PASSWORD_RESET.RepeatPassword' | translate }}</label>
            <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                pInputText
                formControlName="confirmPassword"
                [attr.aria-invalid]="submitAttempt && form.get('confirmPassword').invalid ? true : null"
                [class.error-input]="submitAttempt && (form.get('confirmPassword').hasError('required') || form.get('confirmPassword').hasError('minLength'))"
            >
            @if (submitAttempt && form.get('confirmPassword').hasError('required')) {
              <div class="error-message">
                <span style="color: red">{{ 'RequiredField' | translate }}</span>
              </div>
            }
            @if (submitAttempt && form.get('confirmPassword').hasError('minLength')) {
              <div class="error-message">
                <span style="color: red">{{ 'PASSWORD_RESET.Min6Caracters' | translate }}</span>
              </div>
            }
        </div>
    </form>

    <div class="button-div">
        <button
            [style.background-color]="!isCustomCommunity ? buttonBg : null"
            [style.color]="!isCustomCommunity ? buttonColor : null"
            type="button"
            (click)="sendResetPassword()"
            [disabled]="!form.valid"
            [style.opacity]="!form.valid ? '0.3' : '1'"
        >
        {{ 'Send' | translate }}</button>
    </div>
</div>
}
